import { render } from "./SelectInput.vue?vue&type=template&id=48a57d56&scoped=true"
import script from "./SelectInput.vue?vue&type=script&lang=js"
export * from "./SelectInput.vue?vue&type=script&lang=js"

import "./SelectInput.vue?vue&type=style&index=0&id=48a57d56&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48a57d56"]])

export default __exports__